export const brandVoiceKeys = {
  all: ['brandVoice'] as const,
  list: (accountId: string) =>
    [...brandVoiceKeys.all, 'list', accountId] as const,
  details: (accountId: string, brandVoiceId: string) =>
    [...brandVoiceKeys.all, 'details', accountId, brandVoiceId] as const,
}

export const brandToneKeys = {
  all: ['brandTone'] as const,
  list: () => [...brandToneKeys.all, 'list'] as const,
}
